import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=3a47034d&"
import script from "./SideDrawer.vue?vue&type=script&lang=js&"
export * from "./SideDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SideDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports